<form [formGroup]="urlForm" class="form-line">
  <mat-form-field appearance="outline">
    <mat-label>{{
      type === "rule"
        ? ("ONSIP_I18N.RULE_TYPE" | translate)
        : ("ONSIP_I18N.EXCEPTION_TYPE" | translate)
    }}</mat-label>
    <mat-select formControlName="verb">
      @for (verbItem of verbs; track verbItem) {
      <mat-option [value]="verbItem">{{ translatedVerbItems[verbItem] }}</mat-option>
      }
    </mat-select>
  </mat-form-field>
  <mat-form-field appearance="outline">
    <mat-label>{{
      type === "rule"
        ? ("ONSIP_I18N.URL_RULE" | translate)
        : ("ONSIP_I18N.URL_EXCEPTION" | translate)
    }}</mat-label>
    <input #urlInput matInput formControlName="url" autocomplete="off" />
    @if (urlForm.controls.url.errors) {
    <mat-error>{{ getErrors() }}</mat-error>
    }
  </mat-form-field>
  <button mat-icon-button color="primary" (click)="onDeletePageRule()">
    <mat-icon>delete_outline</mat-icon>
  </button>
</form>
